import { Helmet } from "react-helmet-async";

const defaultMeta = {
  siteName: "Orchestrio",
  siteTitle: "Orchestrio — Digital Systems Studio (UK)",
  description: "Orchestrio designs and builds high-performance websites and applications for UK businesses. Clear systems. Built properly.",
  image: "/orchestrio-logo.png",
  locale: "en_GB",
  url: "https://orchestrio.co.uk"
};

export const SEO = ({ 
  title, 
  description, 
  image,
  type = "website",
  article = null,
  noIndex = false
}) => {
  const pageTitle = title 
    ? `${title} — Orchestrio` 
    : defaultMeta.siteTitle;
  
  const pageDescription = description || defaultMeta.description;
  const pageImage = image || defaultMeta.image;

  return (
    <Helmet>
      <title>{pageTitle}</title>
      <meta name="description" content={pageDescription} />
      
      {noIndex && <meta name="robots" content="noindex, nofollow" />}
      
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={pageDescription} />
      <meta property="og:type" content={type} />
      <meta property="og:image" content={pageImage} />
      <meta property="og:site_name" content={defaultMeta.siteName} />
      <meta property="og:locale" content={defaultMeta.locale} />
      
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description" content={pageDescription} />
      <meta name="twitter:image" content={pageImage} />
      
      {article && (
        <>
          <meta property="article:published_time" content={article.publishedAt} />
          <meta property="article:author" content={article.author} />
          {article.tags?.map((tag, i) => (
            <meta key={i} property="article:tag" content={tag} />
          ))}
        </>
      )}
    </Helmet>
  );
};

export const BlogPostSchema = ({ post }) => {
  if (!post) return null;
  
  const schema = {
    "@context": "https://schema.org",
    "@type": "BlogPosting",
    "headline": post.title,
    "description": post.excerpt,
    "image": post.featured_image,
    "datePublished": post.published_at,
    "dateModified": post.updated_at || post.published_at,
    "author": {
      "@type": "Person",
      "name": post.author
    },
    "publisher": {
      "@type": "Organization",
      "name": "Orchestrio",
      "logo": {
        "@type": "ImageObject",
        "url": "https://orchestrio.co.uk/orchestrio-logo.png"
      }
    },
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": `https://orchestrio.co.uk/blog/${post.slug}`
    }
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schema)}
      </script>
    </Helmet>
  );
};

export default SEO;
